import { trim } from 'ramda';
import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { ITreeSection } from '../../../../../../BaseComponents/TreeSelect/TreeSelectUtils';
import { IRoutineAvailability } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { convertTEDUrvalToUIUrval } from '../../../../../../Components/Urval/Utils/convertTEDUrvalToUIUrval';
import {
  TEDBOResursVARNING_DUBBELBOKNINGEnum,
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../../../../../globalQueryTypes';
import { collectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import {
  IUIUrval,
  TEDUrvalSidaType,
  TEDUrvalType,
} from '../../../../../../Types/UrvalTypes';
import { getCurrentDateString } from '../../../../../../Utils/dateUtils';
import Logger from '../../../../../../Utils/Logger';
import { IFunctionMenuItem } from '../../../../../../Utils/ObjektVyUtils';
import {
  IBusinessDataFormContext,
  IBusinessDataFormState,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  BusinessDataFormAction,
  IFormData,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  MeQuery_me,
  MeQuery_me_bokningsgrupper,
} from '../../../Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import { ResursQuery_db_BOResurs_All } from '../../../Rutiner/Kalender/Queries/ResursQuery/_QueryTypes/ResursQuery';
import {
  IBokningsrubrik,
  ICurrentDayBooking,
  IOverlappedBooking,
} from '../AktivitetResursValjare';
import {
  AktivitetQuery_node_TEDBOAktivitet,
  AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik,
} from '../Queries/_QueryTypes/AktivitetQuery';
import { RepeteraAktivitetPreviewQuery_rtn_BORepeteraAktivitetPreview_aktiviteter } from '../Queries/_QueryTypes/RepeteraAktivitetPreviewQuery';
import { AktivitetType__Associations_AktBokRubrik } from '../_QueryTypes/AktivitetType';
import { combineDateAndTime } from './AktivitetDateTimeFormatter';

export const modifyUpdateResTimeAction = (
  action: BusinessDataFormAction,
  formState: IBusinessDataFormState<IFormData>,
  timeField: string
): void => {
  if (action.type === 'UPDATE' && action.value[timeField]) {
    action.value._Associations = action.value._Associations ?? {};

    formState.currentValues?._Associations?.AktBokRubrik?.forEach(
      (rub: any) => {
        const isNewAktBokRubrik =
          formState.values?._Associations?.AktBokRubrik_Add_Values?.find(
            (rukrik: AktivitetType__Associations_AktBokRubrik) =>
              rub.id === rukrik.id
          );

        if (isNewAktBokRubrik) {
          action.value._Associations.AktBokRubrik_Add_Values =
            action.value._Associations.AktBokRubrik_Add_Values ?? [];
          action.value._Associations.AktBokRubrik_Add_Values.push({
            id: rub.id,
            _version: rub._version,
            [timeField]: action.value[timeField],
          });
        } else {
          action.value._Associations.AktBokRubrik_Update_Values =
            action.value._Associations.AktBokRubrik_Update_Values ?? [];
          action.value._Associations.AktBokRubrik_Update_Values.push({
            id: rub.id,
            _version: rub._version,
            [timeField]: action.value[timeField],
          });
        }
      }
    );
  }
};

export const getGruppUrval = (
  verksamhetstypId: string | undefined,
  fromDate: string | undefined,
  toDate: string | undefined
): IUIUrval | undefined => {
  const verksamhetstypIdAndfromDatePages: TEDUrvalSidaType = [
    {
      namn: 'GILTIG_FROM',
      typ: TEDSelectionConditionType.Value,
      valueCondition: {
        op: TEDSelectionOperator.less,
        value: [
          {
            value: fromDate || getCurrentDateString(),
          },
        ],
      },
    },
  ];

  if (verksamhetstypId) {
    verksamhetstypIdAndfromDatePages.push({
      namn: 'id',
      typ: TEDSelectionConditionType.Value,
      ass: ['Verksamhetstyp'],
      valueCondition: {
        op: TEDSelectionOperator.equals,
        value: [{ value: verksamhetstypId }],
      },
    });
  }

  const tedUrval: TEDUrvalType = [
    [
      ...verksamhetstypIdAndfromDatePages,
      {
        namn: 'GILTIG_TOM',
        typ: TEDSelectionConditionType.Value,
        valueCondition: {
          op: TEDSelectionOperator.greater,
          value: [
            {
              value: toDate || getCurrentDateString(),
              tovalue: null,
            },
          ],
        },
      },
    ],
    [
      ...verksamhetstypIdAndfromDatePages,
      {
        namn: 'GILTIG_TOM',
        typ: TEDSelectionConditionType.Value,
        valueCondition: {
          op: TEDSelectionOperator.isnull,
        },
      },
    ],
  ];

  const result = convertTEDUrvalToUIUrval('BOGruppOP', tedUrval, collectionMap);

  if (result.isOk()) {
    return result.value;
  } else {
    Logger.error(new Error(result.error));
    return undefined;
  }
};

export const aktivitetResursValjareSectionsFromBokningsrubriker = (
  aktBokRubriker: IBokningsrubrik[],
  sections: ITreeSection<any>[]
): ITreeSection<any>[] => {
  return [];
};

export const getCheckedResourcesFromBokningsrubriker = (
  aktBokRubriker: AktivitetType__Associations_AktBokRubrik[]
): string[] => {
  return aktBokRubriker.map(
    aktBokRubrik => aktBokRubrik?._Associations?.Resurs?.id || 'saknar id'
  );
};

export const getBokningsrubrikerFromSections = (
  sections: ITreeSection<IBokningsrubrik>[]
): IBokningsrubrik[] => {
  let bokningsRubriker: IBokningsrubrik[] = [];

  sections.forEach(section => {
    if (section.checked && section.data && !section.subList) {
      bokningsRubriker.push(section.data);
    }

    if (section.subList && section.subList.length > 0) {
      bokningsRubriker = bokningsRubriker.concat(
        getBokningsrubrikerFromSections(section.subList)
      );
    }
  });
  return bokningsRubriker;
};

export const bokningsrubrikFromDbBokningsrubrik = (
  dbBokningsrubrik: AktivitetType__Associations_AktBokRubrik,
  resources: IBokningsrubrik[]
): IBokningsrubrik => ({
  rubrikId: dbBokningsrubrik.id,
  resursText:
    dbBokningsrubrik._Associations?.Resurs?.BO_RESURS_NAMN +
    ` (${dbBokningsrubrik._Associations?.Resurs?._Associations?.ResRestyp?.BO_RESURSTYP_NAMN})`,
  resursNamn: dbBokningsrubrik._Associations?.Resurs?.BO_RESURS_NAMN ?? '',
  BO_RESURS_ID: dbBokningsrubrik._Associations?.Resurs?.BO_RESURS_ID ?? '',
  resursId: dbBokningsrubrik._Associations?.Resurs?.id ?? '',
  resursTyp:
    dbBokningsrubrik._Associations?.Resurs?._Associations?.ResRestyp
      ?.BO_RESURSTYP_NAMN ?? '',
  posNr: dbBokningsrubrik.AKTRESRUB_POSNR ?? undefined,
  resourceInList: resources.some(
    x => x.BO_RESURS_ID === dbBokningsrubrik._Associations?.Resurs?.BO_RESURS_ID
  ),
  resourceTitle: dbBokningsrubrik?.Resursrubrik,
  prio_ordning: dbBokningsrubrik?._Associations?.Resurs?.PRIO_ORDNING,
});

export const bokningsrubrikFromDbResurs = (
  dbResurs: ResursQuery_db_BOResurs_All
): IBokningsrubrik => ({
  resursText:
    dbResurs.BO_RESURS_NAMN +
    ` (${dbResurs._Associations?.ResRestyp?.BO_RESURSTYP_NAMN})`,
  resursNamn: dbResurs.BO_RESURS_NAMN ?? '',
  BO_RESURS_ID: dbResurs.BO_RESURS_ID ?? '',
  resursId: dbResurs.id ?? '',
  resursTyp: dbResurs._Associations?.ResRestyp?.BO_RESURSTYP_NAMN ?? '',
  platsId: dbResurs._Associations?.Forsamling?.id,
});

// Värmestyrning
export interface IVarmeOption {
  name: string;
  value?: number | null;
}

export const varmeInstallningarOptions: IVarmeOption[] = [
  { name: 'Standardvärme', value: 0 },
  {
    name: 'Stabil luftfukt (ingen uppvärmn.)',
    value: -1,
  },
  { name: 'Ingen uppvärmning', value: -2 },
  { name: 'Städtemp', value: -3 },
  { name: 'Valfri temperatur' },
];

export const getVarmeOption = (
  value: number | null | undefined
): IVarmeOption | undefined => {
  if (value !== null && value !== undefined) {
    const matchingOption = varmeInstallningarOptions.find(
      option => option.value === value
    );
    return matchingOption ?? varmeInstallningarOptions[4];
  } else {
    return varmeInstallningarOptions[0];
  }
};

export const varmeWarning = (value: number | null): boolean | undefined => {
  if ((value !== null && value > 30) || (value !== null && value < 15)) {
    return true;
  } else {
    return false;
  }
};

export const varmeHelperText = (value: number | null): string | undefined => {
  if (value !== null && value > 30) {
    return 'Vald temperatur är ovanligt hög.';
  } else {
    return 'Vald temperatur är ovanligt låg.';
  }
};

// Dubbelbokning

export const overlappedBookings = (
  currentDayBookings: ICurrentDayBooking[],
  currentDayXbridgeBookings: ICurrentDayBooking[],
  currentValues: AktivitetQuery_node_TEDBOAktivitet | undefined
) => {
  let result: IOverlappedBooking[] = [];

  let allCurrentDayBookings = currentDayBookings;
  currentDayXbridgeBookings?.forEach(xbooking => {
    if (
      currentDayBookings.findIndex(
        booking =>
          booking.aktTitel === xbooking.aktTitel &&
          booking.resStart === xbooking.resStart &&
          booking.resEnd === xbooking.resEnd
      ) < 0
    )
      allCurrentDayBookings.push(xbooking);
  });

  currentValues?._Associations?.AktBokRubrik?.forEach(
    (item: AktivitetQuery_node_TEDBOAktivitet__Associations_AktBokRubrik) => {
      allCurrentDayBookings.forEach(currentDayBooking => {
        if (
          currentDayBooking.varning_dubbelbokning ===
          TEDBOResursVARNING_DUBBELBOKNINGEnum.NEJ
        ) {
          return;
        }
        if (
          currentDayBooking.aktId !== currentValues?.id &&
          currentDayBooking.BO_RESURS_ID ===
            item._Associations?.Resurs?.BO_RESURS_ID &&
          currentDayBooking.resStart <
            combineDateAndTime(item.TILLDATUM, item.TILLTID) &&
          currentDayBooking.resEnd >
            combineDateAndTime(item.FRANDATUM, item.FRANTID)
        )
          result.push({
            rubrikId: item?.id,
            resourceName: item?._Associations?.Resurs?.BO_RESURS_NAMN ?? '',
            bastyp:
              item?._Associations?.Resurs?._Associations?.ResRestyp.Bastyp ??
              '',
            resStart: currentDayBooking.resStart,
            resEnd: currentDayBooking.resEnd,
            bokNr: currentDayBooking.bokNr,
            aktTitel: currentDayBooking.aktTitel,
          });
      });
    }
  );
  return result;
};

// Rutin behörighet

export const hasRutinKod = (
  targetRutinKod: string,
  availableRoutines: IRoutineAvailability | undefined
): boolean => {
  if (!availableRoutines) return false;
  return Object.values(availableRoutines).some(
    routine => routine?.rutinKod === targetRutinKod
  );
};

export const isReadOnlyRutin = (
  targetRutinKod: string,
  availableRoutines: IRoutineAvailability | undefined
): boolean => {
  if (!availableRoutines) return false;
  return Object.values(availableRoutines).some(
    routine =>
      routine?.rutinKod === targetRutinKod && routine?.readonly === true
  );
};

export const getValidBookingGroups = (
  me: MeQuery_me_bokningsgrupper[] | null | undefined,
  allBookingGroups: ISuggestion[]
) => {
  return allBookingGroups.filter(({ name: validBokningsGrupperName }) =>
    me?.some(
      ({ namn: me_data_bokningsgrupperNamn }) =>
        me_data_bokningsgrupperNamn === validBokningsGrupperName
    )
  );
};

export const checkDoubleBookingInfo = (
  aktivitet: RepeteraAktivitetPreviewQuery_rtn_BORepeteraAktivitetPreview_aktiviteter
) => {
  const msgRubriker = aktivitet?.Bokningsrubriker?.reduce<string | undefined>(
    (msg, rub) =>
      rub?.Resurs?.ResBokad
        ? msg
          ? `${msg}\n${rub?.Resurs?.resurs} - ${trim(rub?.Resurs?.ResBokad)}`
          : `${rub?.Resurs?.resurs} - ${trim(rub?.Resurs?.ResBokad)}`
        : rub?.Resurs?.XBridge
        ? msg
          ? `${msg}\n${rub?.Resurs?.resurs} - ${trim(rub?.Resurs?.XBridge)}`
          : `${rub?.Resurs?.resurs} - ${trim(rub?.Resurs?.XBridge)}`
        : msg,
    undefined
  );
  const msgResurser = aktivitet?.Resurser?.reduce<string | undefined>(
    (msg, res) =>
      res?.ResBokad
        ? msg
          ? `${msg}\n${res?.resurs} - ${trim(res?.ResBokad)}`
          : `${res?.resurs} - ${trim(res?.ResBokad)}`
        : msg,
    undefined
  );
  return {
    Vald: !msgRubriker && !msgResurser,
    Dubbelbokningar:
      msgRubriker && msgResurser
        ? `${msgRubriker}\n${msgResurser}`
        : msgRubriker ?? msgResurser,
  };
};

export const addCustomActivityFunctionMenuItem = (
  functionMenuItems: IFunctionMenuItem[],
  prelbokad: boolean,
  setOpenPremity: React.Dispatch<React.SetStateAction<boolean>>,
  setOpenDeleteRepeterade: React.Dispatch<React.SetStateAction<boolean>>,
  disabled: boolean,
  disabledReason: string | undefined,
  formContext: IBusinessDataFormContext<any, unknown>
): IFunctionMenuItem[] => {
  const [item1, ...rest] = functionMenuItems;

  if (formContext?.formState.currentValues?.AntalRepeteradeAktiviteter > 0) {
    return [
      item1,
      {
        id: 'preliminär',
        disabled,
        disabledReason,
        caption: prelbokad ? 'Gör ej preliminär' : 'Gör preliminär',
        iconType: 'event_completed',
        onClick: () => {
          setOpenPremity(true);
        },
      },
      {
        id: 'repeterade',
        disabled,
        disabledReason,
        caption: 'Ta bort',
        iconType: 'delete',
        onClick: () => {
          setOpenDeleteRepeterade(true);
        },
      },
    ];
  } else
    return [
      item1,
      {
        id: 'preliminär',
        disabled,
        disabledReason,
        caption: prelbokad ? 'Gör ej preliminär' : 'Gör preliminär',
        iconType: 'event_completed',
        onClick: () => {
          setOpenPremity(true);
        },
      },
      ...rest,
    ];
};

/**
 * Checks if a user can edit a specific booking
 * @param nodeData - The activity data
 * @param userData - User data
 * @returns Whether user can edit this booking
 */
export function userCanEditBooking(
  nodeData: AktivitetQuery_node_TEDBOAktivitet | null | undefined,
  userData: MeQuery_me | null | undefined
): boolean {
  return (
    nodeData?._typ === undefined ||
    (nodeData?._typ === 'AKTOVRIGT' && userData?.userCanEditBooking) ||
    (nodeData?._typ === 'AKTOVRIGT' &&
      nodeData?.BOKNINGSSIGNATUR === userData?.sign) ||
    (nodeData?._typ === 'GUDSTJANST' && userData?.userCanEditBooking) ||
    (nodeData?._typ === 'GUDSTJANST' &&
      nodeData?.BOKNINGSSIGNATUR === userData?.sign)
  );
}
